import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { NGXLogger } from "ngx-logger";
import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { Prontofibra_Firestore } from "../models/prontofibra.firestore.model";

@Injectable({
  providedIn: "root",
})
export class ProntofibraCacheService {
  private collection_prontofibra: string =
    environment.firebase.collection_prontofibra;

  private prontofibraByCui = new Map<string, Prontofibra_Firestore>();
  private initialized = false;

  constructor(
    private firestore: AngularFirestore,
    private logger: NGXLogger,
  ) {
    this.init();
  }

  private init(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    const collectionRef = this.firestore.collection(this.collection_prontofibra)
      .ref;

    onSnapshot(
      collectionRef,
      (qs) => {
        const newMap = new Map<string, Prontofibra_Firestore>();

        qs.forEach((doc) => {
          const pf = doc.data() as Prontofibra_Firestore;
          if (pf && pf.cui) {
            newMap.set(pf.cui, pf);
          }
        });

        this.prontofibraByCui = newMap;
        this.logger.info(
          `[PF CACHE] Cache prontofibra aggiornata, elementi: ${this.prontofibraByCui.size}`,
        );
      },
      (error) => {
        this.logger.error(
          "[PF CACHE] Errore nel listener della collection prontofibra",
          error,
        );
      },
    );
  }

  getByCui(cui: string): Prontofibra_Firestore | null {
    if (!cui) {
      return null;
    }
    return this.prontofibraByCui.get(cui) ?? null;
  }
}

